export const currency = {
  USD: 'USD',
  CNY: 'CNY',
  INR: 'INR',
  JPY: 'JPY',
  EUR: 'EUR',
  GBP: 'GBP',
  // KRW: 'KRW',
  // SGD: 'SGD',
  // MYR: 'MYR',
  // IDR: 'IDR',
  // BRL: 'BRL',
};

export type localeListType = {
  [key: string]: string;
};
export const localeList: localeListType = {
  USD: 'en-US',
  CNY: 'zh-CN',
  INR: 'en-IN',
  JPY: 'ja-JP',
  EUR: 'fr-FR',
  GBP: 'en-GB',
  // KRW: 'ko-KR',
  // SGD: 'en-SG',
  // MYR: 'ms-MY',
  // IDR: 'id-ID',
  // BRL: 'pt-BR',
};
